import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
interface BusPickupAllocationIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
const MoonIcon: React.FC<BusPickupAllocationIconProps> = ({
  color,
  ...props
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0935 1.25278C10.5623 1.09653 10.031 0.971532 9.46854 0.877782C9.06229 0.815282 8.62479 1.03403 8.46854 1.40903C8.28104 1.78403 8.37479 2.25278 8.68729 2.50278C10.906 4.56528 11.7185 7.59653 10.8123 10.4403C9.81229 13.5965 6.87479 15.8153 3.46854 15.909C3.03104 15.909 2.68729 16.1903 2.56229 16.5965C2.43729 17.0028 2.62479 17.4403 2.96854 17.659C3.74979 18.1278 4.53104 18.5028 5.31229 18.7528C6.21854 19.034 7.15604 19.159 8.09354 19.159C9.68729 19.159 11.2498 18.7528 12.656 17.9715C14.8748 16.7528 16.4373 14.784 17.1248 12.409C18.4685 7.72153 15.8123 2.81528 11.0935 1.25278ZM15.781 12.0028C15.2185 14.034 13.8435 15.6903 11.9998 16.7215C10.0623 17.784 7.84354 18.0028 5.74979 17.3778C5.53104 17.3153 5.28104 17.2215 5.06229 17.1278C8.37479 16.4715 11.1248 14.0965 12.156 10.8465C13.0623 7.97153 12.4998 4.94028 10.656 2.56528C14.656 3.90903 16.906 8.06528 15.781 12.0028Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default MoonIcon;
